import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SEGMENTS } from 'app/core/constants/gallery';
import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
@Component({
  selector: 'app-lndp-gallery-mobile',
  templateUrl: './lndp-gallery-mobile.component.html',
  styleUrls: ['./lndp-gallery-mobile.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    MatIconModule,
    TranslateModule,
    MatSelectModule,
    MatFormFieldModule,
    MatMenuModule,
    CarouselModule
  ]
})
export class LndpGalleryMobileComponent implements OnInit {

  imageObjectAW: Array<any> = [];
  imageObjectANM: Array<any> = [];
  imageObjectNS: Array<any> = [];
  imageObjectFA: Array<any> = [];

  responsiveOptions: any = [
    {
        breakpoint: '1400px',
        numVisible: 3,
        numScroll: 3,
    },
    {
        breakpoint: '1220px',
        numVisible: 2,
        numScroll: 2,
    },
    {
        breakpoint: '1100px',
        numVisible: 1,
        numScroll: 1,
    },
];

  @Input() imagesAW;
  @Input() imagesANM;
  @Input() imagesNS;
  @Input() imagesFA;

  pickedSegment: string = '';
  initialSelectedValue: string = '';

  ADVISORY_WORKSHOP = 'LNDP_CALENDAR.ADVISORY_WORKSHOP';
  ACCESS_NEW_MARKETS = 'LNDP_CALENDAR.ACCESS_NEW_MARKETS';
  NETWORKING_SESSION = 'LNDP_CALENDAR.NETWORKING_SESSION';
  FINANCIAL_ADVISORY = 'LNDP_CALENDAR.FINANCIAL_ADVISORY';
  SEGMENT_FA = SEGMENTS.FINANCIAL_ADVISORY;
  SEGMENT_AWP = SEGMENTS.ADVISORY_WORKSHOP;
  SEGMENT_ANM = SEGMENTS.ACCESS_NEW_MARKETS;
  SEGMENT_NS = SEGMENTS.NETWORKING_SESSION;

  dropDownData: any = [
    { value: SEGMENTS.FINANCIAL_ADVISORY, viewValue: 'LNDP_CALENDAR.FINANCIAL_ADVISORY'},
    { value: SEGMENTS.ADVISORY_WORKSHOP, viewValue: 'LNDP_CALENDAR.ADVISORY_WORKSHOP'},
    { value: SEGMENTS.ACCESS_NEW_MARKETS, viewValue: 'LNDP_CALENDAR.ACCESS_NEW_MARKETS'},
    { value: SEGMENTS.NETWORKING_SESSION, viewValue: 'LNDP_CALENDAR.NETWORKING_SESSION'},
  ];

  ngOnInit() {
    this.getInitialDropdownValue();
  }

  getInitialDropdownValue() {
    if (this.imageObjectFA.length) this.initialSelectedValue = this.FINANCIAL_ADVISORY;
    else if (this.imageObjectAW.length) this.initialSelectedValue = this.ADVISORY_WORKSHOP;
    else if (this.imageObjectANM.length) this.initialSelectedValue = this.ACCESS_NEW_MARKETS;
    else  this.initialSelectedValue = this.NETWORKING_SESSION;
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes) {
      this.imageObjectFA = changes?.imagesFA?.currentValue ? changes?.imagesFA?.currentValue : [];
      this.imageObjectAW = changes?.imagesAW?.currentValue ? changes?.imagesAW?.currentValue : [];
      this.imageObjectANM = changes?.imagesANM?.currentValue ? changes?.imagesANM?.currentValue : [];
      this.imageObjectNS = changes?.imagesNS?.currentValue ? changes?.imagesNS?.currentValue : [];
    }
  }

  selectedSegment(segment: any) {
    this.dropDownData.forEach((x: any) => {
      if(segment == x.value) {
        this.initialSelectedValue = x.viewValue;
      }
    });
  }
}
